module.exports = "varying vec4 vColor;\n\nvoid main() {\n  gl_FragColor = vColor;\n}"